var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { postDataParse } from "./common";
export var responseSgmReport = function (response) {
    try {
        var _a = response.config, method = _a.method, headers = _a.headers;
        var responseData = response.data;
        var logMsg = {
            request: null,
            functionId: "",
            header: headers,
            response: responseData,
        };
        if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "GET" && response.config.params) {
            logMsg.functionId = response.config.params.functionId || "";
            logMsg.request = response.config.params.body;
        }
        if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "POST" && response.config.data) {
            var parseData = postDataParse(response.config.data);
            logMsg.functionId = parseData.functionId;
            logMsg.request = parseData.body;
        }
        // 自定义上报log data：__jdhfeDynamic__通过cdn加载
        var customLog = null;
        if (Object.prototype.hasOwnProperty.call(global.window, "__jdhfeDynamic__")) {
            var sgmHandler = __assign({}, global.window.__jdhfeDynamic__).sgmHandler;
            customLog = sgmHandler && sgmHandler(__assign({}, logMsg));
        }
        if (Object.prototype.hasOwnProperty.call(global.window, "__sgm__")) {
            /* eslint no-underscore-dangle: "off" */
            if (customLog) {
                global.window.__sgm__.custom(customLog);
            }
            else if (responseData.code === "1023") {
                //   登录态失效
                global.window.__sgm__.custom({
                    type: "1",
                    code: "response code is 1023",
                    msg: logMsg,
                });
            }
            else if (responseData.code !== "0000" && responseData.code !== "0") {
                // 状态码异常
                global.window.__sgm__.custom({
                    type: "1",
                    code: "response code is ".concat(responseData.code),
                    msg: logMsg,
                });
            }
            else if (!responseData.data) {
                // 返回值为空
                global.window.__sgm__.custom({
                    type: "3",
                    code: "response data is undefined",
                    msg: logMsg,
                });
            }
            else {
                // 默认上报正常数据
                global.window.__sgm__.custom({
                    type: "3",
                    code: "response data info",
                    msg: logMsg,
                });
            }
        }
    }
    catch (catchError) {
        console.log("responseSgmReport error");
    }
    return response;
};
